<script>
import api from "@/axios";
import Loader from "../components/loader.vue";
import Layout from '../../layouts/main.vue'
import PageHeader from '@/components/page-header.vue'
import TransferenciasTable from './transferencias-table.vue'
import appConfig from "@/app.config.json";
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/transf_anim.json'
import { pedidosChart1, pedidosChart2 } from "../components/data-simulados"
import exportFromJSON from "export-from-json"
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Transferências",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, TransferenciasTable, Loader, Vue3Lottie },
  mounted() {
    console.log('mounted transferencias-list_0')
    this.atualizaDataList()
  },
  data() {
    return {
      animationJson,
      title: 'Transferências',
      items: [
        {
          text: 'Estoque',
          href: '/',
        },
        {
          text: 'Transferências',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      pedidoList: null,
      pesqTextFilter: '',
      statusFilter: 'T',

      pedChart1: pedidosChart1,
      pedChart2: pedidosChart2

    }
  },
  methods: {
    exportExcel(){
      console.log('exportExcel')
      const data = this.pedidoList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    atualizaDataList(){
      this.loadingList = true
      api.get(`${getBaseUrl()}api/movtransfs`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data[0])
        this.pedidoList = res.data[0]
        this.title = `(${this.pedidoList.length}) Transferências da semana`
        this.loadingList = false
        this.loadingGraph = false
      });
    },

    criarNovo() {
      console.log('criarNovo')
      // this.updating = !this.updating
    }
  },

}
</script>

<template>
  <Layout>

    <span class="float-end" style="z-index: 1000; position: absolute; top: 00px; right: 230px;">
      <Vue3Lottie :animationData="animationJson" :height="300" :width="300" />
    </span>

    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">


              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="EL">Elaboração</option>
                      <option value="CO">Confirmados</option>
                      <option value="CA">Cancelados</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>


              <div class="col-sm-2">
                <div class="mb-2 d-inline-block">
                  <div class="position-relative">
                    <b-button variant="outline-primary" class="" @click="exportExcel">
                      <i class="bx bx-export font-size-16 align-middle "></i>
                    </b-button>
                  </div>
                </div>
              </div>

              <div class="col-sm-7">
                <div class="text-sm-end">
                  <router-link :to="`/movtransf/editar/0`">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" >
                      <i class="mdi mdi-plus me-1"></i> Nova Transferência
                    </button>
                  </router-link>
                </div>

              </div>
            </div>


            <Loader v-if="loadingList" style="min-height: 400px;">
            </Loader>

            <TransferenciasTable v-if="!loadingList"  :pedidoList="pedidoList"/>


            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">2</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">3</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">4</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">5</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <div class="row" v-if="!loadingGraph">

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Evolução Anual</h4>

            <apexchart
                class="apex-charts"
                height="350"
                type="line"
                dir="ltr"
                :series="pedChart1.series"
                :options="pedChart1.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Fornecedores</h4>

            <apexchart
                class="apex-charts"
                height="320"
                type="pie"
                dir="ltr"
                :series="pedChart2.series"
                :options="pedChart2.chartOptions"
            ></apexchart>

          </div>
        </div>
      </div>


    </div>


  </Layout>
</template>
